import React from "react";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import { useMyTimesheetClientsList } from "my-timesheet/hooks";
import { OcFormEditorItemList } from "oc/components";
import { useOcFormEditorSelector } from "oc/hooks";

interface MyTimesheetClientSelectorProps {
  formik: FormikProps<any>;
}

export const MyTimesheetClientSelector = ({
  formik,
}: MyTimesheetClientSelectorProps) => {
  const { t } = useTranslation();

  const { data: clientsData } = useMyTimesheetClientsList({
    page: 1,
    pageSize: 100,
    sort: "name",
    sortDirection: "asc",
    searchField: "",
    searchText: "",
  });

  const {
    list: clientList,
    search: clientSearch,
    selectedItem: selectedClient,
    handleSearch: handleClientSearch,
    handleClearSearch: handleClientClearSearch,
    handleHasMore: handleClientHasMore,
  } = useOcFormEditorSelector({
    value: formik.values.clientId,
    list:
      (clientsData?.rows || []).map((client) => ({
        code: client.code,
        name: client.name,
        validTo: client.validTo
      })),
  });

  const handleChange = (value: string | number) => {
    formik.setFieldValue("clientId", value);
  };

  return (
    <OcFormEditorItemList
      key={"client"}
      value={selectedClient}
      list={clientList}
      label={t("MY_TIMESHEET_CLIENT")}
      search={clientSearch}
      onSearch={handleClientSearch}
      onChange={(_type, value) => handleChange(value)}
      onClearSearch={handleClientClearSearch}
      onScroll={handleClientHasMore}
      name={"client"}
      error={false}
      module="MyTimesheet"
    />
  );
};

export default MyTimesheetClientSelector;
